var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 25C0.5 11.1929 11.6929 0 25.5 0V0C39.3071 0 50.5 11.1929 50.5 25V25C50.5 38.8071 39.3071 50 25.5 50V50C11.6929 50 0.5 38.8071 0.5 25V25Z",
    fill: "white",
    fillOpacity: 0.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24.5415L32.5 24.5415",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7559 20.9999L33.2975 24.5415L29.7559 28.0832",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButton);
export default __webpack_public_path__ + "static/media/arrow_button.858c467d3020c1dcc71bf61c9ceb387b.svg";
export { ForwardRef as ReactComponent };